import styled from 'styled-components'
import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const FilterBar = styled.div`
    background-color: #fff;
    border-bottom: 2px solid #e1e1e15c;
    position: relative;
  
    // Scroll shadows
    .right-shadow {
        box-shadow: inset -7px 0 9px -5px rgba(0,0,0,0.4);
    }
    .left-shadow {
        box-shadow: inset 12px 0 9px -7px rgba(0,0,0,0.4);
    }

    .both-shadow {
        box-shadow: 0 0.5px 0px 0px white inset,
                    0 -0.5px 0px 0px white inset,
                    inset 12px 0 9px -7px rgba(0,0,0,0.4),
                    inset -7px 0 9px -5px rgba(0,0,0,0.4);
      }

    .filterSelected {
        border-bottom: 4px solid black;
        font-weight: 600;
    }

    .filterUnselected {
        border-bottom:  4px solid #fff0;
        font-weight: 200;
    }

    div {
        flex-direction: row;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 auto;
        display: flex;
        max-width: 72rem;
        margin-bottom: 0.5px;

        @media (max-width: 40em) {
            overflow: scroll;
            transition: "box-shadow 0.3s",
        }
    }

    button:first-of-type {
        margin-left: 1rem;
        @media (max-width: 40em) {
             margin-left: 0.5rem;
        }
    }
    button {
        font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        background-color: unset;
        font-size: 18px;
        font-weight: 600;
        padding: 1rem 1rem .5rem 1rem;
        border: none;
        border-bottom: none;
        cursor: pointer;
        
        div {
            color: #4D4D4D;
            font-size: 16px;
            display: inline;
            padding: 2px 2px 2px 6px;
            position: relative;
            top: -1px;
        }
      }
  }
 

`
